import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import styled from "styled-components";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import { parseDate } from "../../utils/date";
import Notification from "../Notification/Notification";

const msgs = defineMessages({
  availability: {
    id: "room_selection.notification.availability",
    description: "Notification of availability on selected dates",
    defaultMessage: "Available for",
  },
  notAvailable: {
    id: "room_selection.notification.notAvailable",
    description: "Notification of availability on selected dates",
    defaultMessage: "Not available for",
  },
  nights: {
    id: "room_selection.notification.nights",
    description: "Notification of availability on selected dates",
    defaultMessage: "night/s",
  },
});

const Month = styled.span`
  text-transform: uppercase;
  font-weight: bold;
`;

const StyledNotification = styled(Notification)`
  visibility: visible !important;
`;

function AvailabilityNotification({
  className,
  hide,
  startDate,
  endDate,
  numberOfNights,
  isPropertyAvailable,
  intl: { formatDate },
}) {
  if (isPropertyAvailable) {
    return null;
  }
  const startDateObj = parseDate(startDate);
  const endDateObj = parseDate(endDate);
  const startDateElem = (
    <span>
      <Month>
        {formatDate(startDateObj, { day: "2-digit" })}{" "}
        {formatDate(startDateObj, { month: "short" }).substring(0, 3)}
      </Month>{" "}
      <span>{formatDate(startDateObj, { year: "numeric" })}</span>
    </span>
  );

  const endDateElem = (
    <span>
      <Month>
        {formatDate(endDateObj, { day: "2-digit" })}{" "}
        {formatDate(endDateObj, { month: "short" }).substring(0, 3)}
      </Month>{" "}
      <span>{formatDate(endDateObj, { year: "numeric" })}</span>
    </span>
  );

  return (
    <StyledNotification
      className={`${className} wbkv9-AvailabilityNotification`}
      text={
        <span>
          <FormattedMessage {...msgs.notAvailable} /> {startDateElem} {" - "} {endDateElem}{" "}
          <span className="nightsText">
            ({numberOfNights} <FormattedMessage {...msgs.nights} />)
          </span>
        </span>
      }
      type="error"
      hide={hide}
      borderRadius
    />
  );
}

AvailabilityNotification.propTypes = {
  className: PropTypes.string,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  hide: PropTypes.bool.isRequired,
  isPropertyAvailable: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(pure(AvailabilityNotification));
